import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { PlayerModule } from '../../_extra/player/player.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { CallLogComponent } from './call_log.component';
import { QueueLogComponent } from './queue_log.component';
import { AgentLogComponent } from './agent_log.component';
import { CallcenterStatsComponent } from './callcenter.component';

import { TimePipe } from './pipes/totime.pipe';
import { StringReplacePipe } from './pipes/stringreplace.pipe';
import { NumberFormatPipe } from './pipes/toNumber.pipe';
import { TimeFormatPipe } from './pipes/timeFormat.pipe';
import { FiltroPorTipoPipe, TiempoTotalPipe, TiempoPromedioPipe, FiltroCantidad, FiltroTiempoEnStats } from './pipes/stats.pipe'

import { ChartModule } from 'angular2-highcharts';
import { UIModule } from '../../_extra/ui/ui.module';
import * as highcharts from 'highcharts';
import { SortByField } from './pipes/sortByField.pipe';
import { AgentNamePipe } from './pipes/agentName.pipe';
import { QueuesAllowedPipe } from './pipes/queuesAllowed.pipe';
import { ChannelFormatPipe } from './pipes/channel-format.pipe';
import { QueueCallbackLogComponent } from './queue-callback-log/queue-callback-log.component';
import { QueueCallbackStatsPipe } from './pipes/queue-callback-stats.pipe';
import { QueueCallbackLogStatsPipe } from './pipes/queue-callback-log-stats.pipe';
import { ToMinutesPipe } from './pipes/to-minutes.pipe';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, BrowserModule, NgxPaginationModule, PlayerModule, ChartModule.forRoot(highcharts), UIModule],
    declarations: [CallLogComponent, QueueLogComponent, AgentLogComponent, CallcenterStatsComponent, TimePipe, StringReplacePipe, NumberFormatPipe, TimeFormatPipe, 
        FiltroPorTipoPipe, TiempoTotalPipe, TiempoPromedioPipe, FiltroCantidad, FiltroTiempoEnStats, SortByField, AgentNamePipe, QueuesAllowedPipe, ChannelFormatPipe, QueueCallbackLogComponent, QueueCallbackStatsPipe, QueueCallbackLogStatsPipe, ToMinutesPipe
    ],
    exports: [CallLogComponent, QueueLogComponent, AgentLogComponent, CallcenterStatsComponent, TimePipe, StringReplacePipe, NumberFormatPipe, TimeFormatPipe, 
        FiltroPorTipoPipe, TiempoTotalPipe, TiempoPromedioPipe, FiltroCantidad, FiltroTiempoEnStats, SortByField, AgentNamePipe, QueuesAllowedPipe
    ]
})
export class ReportesModule {}
